// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".amount[data-v-4c99f100] {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.amount__amount[data-v-4c99f100] {\n  width: 100%;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-around;\n  flex-wrap: wrap;\n}\nspan[data-v-4c99f100] {\n  font-weight: bold;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
